module.exports = __webpack_public_path__ + "static/img/login-background.4a5b020.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b122/login-background.png
// module id = kaMZ
// module chunks = 0